import React, { useEffect, useMemo, useState } from "react";
import { Loader, Label, Icon } from "semantic-ui-react";
import { useAuth } from "../../../../hooks";
import { simulatorApi } from "../../../../api";
import "./ServerItem.scss";

export function SimPreviewGrid({ items = [], max = 6 }) {
  const { accessToken } = useAuth();
  const [docs, setDocs] = useState(null);

  const { readyDocs, missingIds } = useMemo(() => {
    const ready = [];
    const missing = [];

    for (const it of items || []) {
      if (!it) continue;
      if (typeof it === "object") {
        const id = String(it._id || it.id || "");
        const hasData = Boolean(it.title || it.miniature);
        if (hasData) {
          ready.push({
            _id: id,
            title: it.title || "",
            miniature: it.miniature || "",
          });
        } else if (id) {
          missing.push(id);
        }
      } else {
        missing.push(String(it)); // id suelto
      }
    }
    return { readyDocs: ready, missingIds: Array.from(new Set(missing)) };
  }, [items]);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        if (missingIds.length === 0) {
          setDocs(readyDocs);
          return;
        }

        const fetched = [];
        for (const id of missingIds) {
          try {
            const res = await simulatorApi.getSimulatorById(accessToken, id);
            // 🔎 LOG de diagnóstico:
            // eslint-disable-next-line no-console
            console.debug("[SimPreviewGrid] GET /simulators/:id", id, res);

            const s =
              res?.simulator ||
              (Array.isArray(res?.simulators) && res.simulators[0]) ||
              null;

            if (s) {
              fetched.push({
                _id: String(s._id),
                title: s.title || "",
                miniature: s.miniature || "",
              });
            } else {
              fetched.push({ _id: String(id), title: "", miniature: "" });
            }
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error("[SimPreviewGrid] error fetch simulator", id, e);
            fetched.push({ _id: String(id), title: "", miniature: "" });
          }
        }

        if (!cancel) setDocs([...readyDocs, ...fetched]);
      } catch (e) {
        if (!cancel) setDocs(readyDocs);
      }
    })();
    return () => {
      cancel = true;
    };
  }, [readyDocs, missingIds, accessToken]);

  if (!docs) return <Loader active inline="centered" size="small" />;

  const limited = docs.slice(0, max);
  const extra = docs.length - limited.length;

  return (
    <div className="server-card__sims">
      {limited.map((s) => (
        <div className="mini-sim" key={s._id} title={s.title || s._id}>
          <div className="mini-sim__thumb">
            {s.miniature ? (
              <img src={s.miniature} alt={s.title || s._id} />
            ) : (
              <div className="mini-sim__placeholder">
                <Icon name="image outline" />
              </div>
            )}
          </div>
          <div className="mini-sim__title">{s.title || s._id}</div>
        </div>
      ))}
      {extra > 0 && (
        <Label
          size="mini"
          color="blue"
          className="mini-sim__more"
          title={`${extra} más`}
        >
          +{extra}
        </Label>
      )}
    </div>
  );
}
